import * as requestFromServer from "./HowToJoinCrud";
import { HowToJoinSliceAM, callTypes } from "./HowToJoinSlice";
import { NotificationManager } from "react-notifications";

const { actions } = HowToJoinSliceAM;

export const fetchHowToJoinList = queryParams => dispatch => {
  dispatch(actions.startCall({ callType: callTypes.list }));
  return requestFromServer
    .getHowtoJoinList(queryParams)
    .then(response => {
      const totalCount = response.count;
      const entities = response.list;
      dispatch(actions.HowToJoinList({ totalCount, entities }));
    })
    .catch(error => {
      const errMsg = error.response && error.response.data.msg;
      NotificationManager.error(errMsg, 'Error');
      dispatch(actions.catchError({ error, callType: callTypes.list }));
    });
};
export const fetchCompanyDropdownList = (queryParams) => (dispatch) => {
  dispatch(actions.emptyList());
  dispatch(actions.startCall({ callType: callTypes.list }));
  return requestFromServer
    .fetchCompanyDropdownList(queryParams)
    .then((response) => {
      console.log("response::All Company List", response);
      // const { totalCount, entities } = response.data;
      const companyDropdownList = response;
      console.log("fetchCompanyDropdownList", companyDropdownList);
      dispatch(actions.CompanyDropdownList({ companyDropdownList }));
    })
    .catch((error) => {
      const errMsg =
        error.response && error.response.data && error.response.data.errors
          ? error.response.data.errors[0].msg
          : error.message;
      NotificationManager.error(errMsg, "Error");
      dispatch(actions.catchError({ error, callType: callTypes.list }));
    });
};
export const deleteHowtoJoin = queryParams => dispatch => {
  return requestFromServer
    .deleteHowtoJoin(queryParams)
    .then(response => {
      dispatch(actions.deleteHowtoJoin({ response }));
    })
    .catch(error => {
      // console.log(error.response)
      const errMsg = error.response && error.response.data.msg;
      NotificationManager.error(errMsg, 'Error');
      dispatch(actions.catchError({ error, callType: callTypes.list }));
    });
};

export const fetchGameList = queryParams => dispatch => {
  return requestFromServer
    .getAllGamesList(queryParams)
    .then(response => {
      const games = response
      console.log("fetchGameList", games)
      return games;
    })
    .catch(error => {
      const errMsg = error.response && error.response.data && error.response.data.errors ? error.response.data.errors[0].msg : error.message;
      NotificationManager.error(errMsg, 'Error');
      dispatch(actions.catchError({ error, callType: callTypes.list }));
    });
};


export const fetchGameList2 = queryParams => dispatch => {
  return requestFromServer
    .getAllGamesList(queryParams)
    .then(response => {
      const gameDropdownList = response.list
      console.log("fetchGameList2", gameDropdownList)
      dispatch(actions.GameDropdownList({ gameDropdownList }));
    })
    .catch(error => {
      const errMsg = error.response && error.response.data && error.response.data.errors ? error.response.data.errors[0].msg : error.message;
      NotificationManager.error(errMsg, 'Error');
      dispatch(actions.catchError({ error, callType: callTypes.list }));
    });
};
export const createItem = item => dispatch => {
  dispatch(actions.startCall({ callType: callTypes.action }));
  return requestFromServer
    .createItem(item)
    .then(response => {
      const { item } = response;
      NotificationManager.success('success', 'Data saved successfully!');
      // dispatch(actions.itemCreated({ item }));
      return true;
    })
    .catch(error => {
      const errMsg = error.response && error.response.data && error.response.data.errors ? error.response.data.errors[0].msg : error.message;
      NotificationManager.error(errMsg, 'Error');
      dispatch(actions.catchError({ error, callType: callTypes.action }));
    });
};

export const updateItem = item => dispatch => {
  dispatch(actions.startCall({ callType: callTypes.action }));
  return requestFromServer
    .updateItem(item)
    .then(() => {
      NotificationManager.success('success', 'Data saved successfully!');
      // dispatch(actions.itemUpdated({ item }));
      return true;
    })
    .catch(error => {
      // error.clientMessage = "Can't update item";
      const errMsg = error.response && error.response.data && error.response.data.errors ? error.response.data.errors[0].msg : error.message;
      NotificationManager.error(errMsg, 'Error');
      dispatch(actions.catchError({ errMsg, callType: callTypes.action }));
      return false;
    });
};


export const uploadImage = (queryParams) => dispatch => {
  return requestFromServer
    .uploadImage(queryParams.img)
    .then(response => {
      const entities = response.data.image;
      const imageField = queryParams.type;
      return { entities, imageField }
      // dispatch(actions.imageUploaded({ entities, imageField }));
    })
    .catch(error => {
      // console.log('error', error)
      const errMsg = error.response && error.response.data && error.response.data.errors ? error.response.data.errors[0].msg : error.message;
      NotificationManager.error(errMsg, 'Error');
      dispatch(actions.catchError({ error, callType: callTypes.list }));
    });
};

export const createHowToJoin = body => dispatch => {
  return requestFromServer
    .createHowToJoin(body)
    .then(response => {
      return response
      // dispatch(actions.deleteHowtoJoin({ response }));
    })
    .catch(error => {
      const errMsg = error.response && error.response.data.msg;
      NotificationManager.error(errMsg, 'Error');
      dispatch(actions.catchError({ error, callType: callTypes.list }));
    });
};
export const updateHowToJoin = (body, id) => dispatch => {
  return requestFromServer
    .updateHowToJoin(body, id)
    .then(response => {
      return response
      // dispatch(actions.deleteHowtoJoin({ response }));
    })
    .catch(error => {
      const errMsg = error.response && error.response.data.msg;
      NotificationManager.error(errMsg, 'Error');
      dispatch(actions.catchError({ error, callType: callTypes.list }));
    });
};
export const statusUpdateHowToJoin = (body, id) => dispatch => {
  return requestFromServer
    .statusUpdateHowToJoin(body, id)
    .then(response => {
      return response
    })
    .catch(error => {
      const errMsg = error.response && error.response.data.msg;
      NotificationManager.error(errMsg, 'Error');
      dispatch(actions.catchError({ error, callType: callTypes.list }));
    });
};
export const updateE = (data) => dispatch => {
  if (data?.count && data?.list) {
    const totalCount = data.count;
    const entities = data.list;
    dispatch(actions.HowToJoinList({ totalCount, entities }));
  }

};
export const fetchSingle = id => dispatch => {
  console.log("^^id", id)
  return requestFromServer
    .fetchSingle(id)
    .then(response => {
      dispatch(actions.singleItemFetched(response));
    })
    .catch(error => {
      // console.log(error.response)
      const errMsg = error.response && error.response.data.msg;
      NotificationManager.error(errMsg, 'Error');
      dispatch(actions.catchError({ error, callType: callTypes.list }));
    });
};


export const fetchCountryList = (queryParams) => (dispatch) => {
  // console.log("queryParams",queryParams)
  dispatch(actions.emptyList());
  dispatch(actions.startCall({ callType: callTypes.list }));
  // console.log('queryParams: ', queryParams)
  return requestFromServer
    .getCountry(queryParams)
    .then((response) => {
      // console.log("response::getGameList ", response);
      // const { totalCount, entities } = response.data;
      const totalCount = response.totalRecord;
      const entities = response.data;
      dispatch(actions.country({ totalCount, entities }));
    })
    .catch((error) => {
      const errMsg =
        error.response && error.response.data && error.response.data.errors
          ? error.response.data.errors[0].msg
          : error.message;
      NotificationManager.error(errMsg, "Error");
      dispatch(actions.catchError({ error, callType: callTypes.list }));
    });
};

export const defineNullProperty = () => dispatch => {
  dispatch(actions.nullProperty({}));
};